import { Col, Icon, Row, Text, UploadButton } from 'components';
import { imageResizer } from 'core';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const dimensions = [600, 350, 150];

const Preview = styled.div`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 7px;
  background-image: ${(props) => `url(${props.img})`};
  width: 320px;
  height: 320px;
  z-index: 1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin: 5px 0;
`;

const CloseContainer = styled.div`
  right: -30px;
  position: absolute;
  cursor: pointer;
`;

const Image = ({ text, imgs, setImgs, removeImage, type }) => {
  const fileInput = useRef(null),
    [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!imgs) return;

    setPreview(imgs.data[0]);
  }, []);

  function openFilePicker() {
    fileInput.current.click();
  }

  function removeFile() {
    setImgs(null);
    setPreview(null);
    fileInput.current.value = '';

    removeImage();
  }

  async function handleFile(e) {
    const file = e?.target?.files[0];
    if (!file) return;
    let files = [];

    const mapped = dimensions.map(async (dim, i) => {
      const image = await imageResizer({
        height: dim,
        width: dim,
        format: 'jpeg',
        file,
        output: 'blob',
        quality: 70
      });

      return image;
    });
    await Promise.all(mapped).then((res) => (files = res));

    setImgs(files, type);
    setPreview(URL.createObjectURL(files[0]));
  }

  return (
    <Col>
      {preview && (
        <Preview img={preview} onClick={removeFile}>
          <CloseContainer>
            <Icon type="close" />
          </CloseContainer>
        </Preview>
      )}

      <Row start>
        {text && <Text>{text}</Text>}

        {!preview && <UploadButton onClick={openFilePicker} />}

        <input
          type="file"
          ref={fileInput}
          style={{ width: 0, height: 0, opacity: 0 }}
          onChange={(event) => handleFile(event)}
        />
      </Row>
    </Col>
  );
};

export default Image;
